// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo{max-width:70%}.bookview{position:fixed;top:0;bottom:0;left:0;right:0;background-color:#fff;z-index:200;display:flex;justify-content:center}.bookview .topbar{box-shadow:none}.inactive{color:#d3d3d3}", ""]);
// Exports
module.exports = exports;
